import React from "react";
import ExportCSVPaginated from "../ExportCsvPaginated";
import DataTable from "./DataTable";
import TablePagination from "./TablePagination";
import { columnsFromFields, formatResultCount } from "./listHelpers";

// ============================================================
// Carte de résultats du kit (compteur, export, tableau, pagination) pour les
// listes historiques qui décrivent leurs colonnes au format de `common/Table`
// ({ name, path, render, exportPath }) : mêmes cellules et même export CSV
// qu'avec Table + Pagination, mais à la largeur de la carte de recherche,
// comme les listes du kit.
// - `exportOptions` : les options d'export de Table, telles quelles ; le
//   bouton reste réservé au privilège `export_csv`.
// - `hasSearched` : avant la première recherche, « Lancez une recherche »
//   plutôt que « Aucun résultat ».
// - `countText` remplace le compteur calculé (`count` + `countLabels`).
// - Sans `onChangePage`, pas de pagination (liste complète).
// Les lignes gardent leur rang pour clé, comme dans Table.
// ============================================================

const cleParRang = (row, index) => index;

const ResultsCard = ({
  fields = [],
  rows = [],
  count = 0,
  countLabels,
  countText = null,
  hasSearched = true,
  isLoading = false,
  error = null,
  caption = null,
  emptyState,
  idleState,
  exportOptions = null,
  page = 1,
  nbPages = 1,
  nbItemsByPage = 25,
  onChangePage = null,
  onChangeNbItemsByPage = () => {},
  itemLabel,
  ariaLabel = "Résultats",
  className = "",
}) => (
  <section className={`list-card ${className}`.trim()} aria-label={ariaLabel}>
    <div className="results-bar">
      <p className="results-bar__count" role="status" aria-live="polite">
        {!hasSearched ? "Aucune recherche lancée" : countText || formatResultCount(count, countLabels)}
      </p>
      {exportOptions && (
        <div className="results-bar__actions" data-priv="export_csv">
          <ExportCSVPaginated
            fields={[...(exportOptions.fields || fields), ...(exportOptions.additionalFields || [])]}
            datas={exportOptions.datas}
            exportOptions={{ ...exportOptions, paginated: true }}
            csvDelimiter={exportOptions.csvDelimiter || ","}
          />
        </div>
      )}
    </div>
    <DataTable
      caption={caption}
      columns={columnsFromFields(fields)}
      rows={rows}
      rowKey={cleParRang}
      isLoading={isLoading}
      hasSearched={hasSearched}
      error={error}
      emptyState={emptyState}
      idleState={idleState}
    />
    {onChangePage && (
      <TablePagination
        page={page}
        nbPages={nbPages}
        count={count}
        nbItemsByPage={nbItemsByPage}
        onChangePage={onChangePage}
        onChangeNbItemsByPage={onChangeNbItemsByPage}
        itemLabel={itemLabel}
      />
    )}
  </section>
);

export default ResultsCard;
